import http from '@/communication/AuthConnection'
import Store from '@/state'

export default () => {
  const quoteId = Store.getters['ItemAssociation/GET_ITEM_SELECTED_ID']

  return new Promise((resolve, reject) => {
    http.get(`/v1/item-association/message/${quoteId}`)
      .then((quotePayload) => {
        return resolve(quotePayload.data.quote.message)
      })
  })
}



// WEBPACK FOOTER //
// ./src/brain/item-association/ReadReview.js